import { AfterContentInit, Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { TemplateDirective } from '../../organisms';

@Component({
  selector: 'app-system-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent implements AfterContentInit {
  /**
   * Current value of the progress.
   * @group Props
   */
  @Input() value: number | undefined;
  /**
   * Whether to display the progress bar value.
   * @group Props
   */
  @Input() showValue = true;
  /**
   * Class of the element.
   * @group Props
   */
  @Input() styleClass!: string;
  /**
   * Inline style of the element.
   * @group Props
   */
  @Input() style: { [klass: string]: any } | null | undefined;
  /**
   * Unit sign appended to the value.
   * @group Props
   */
  @Input() unit = '%';
  /**
   * Defines the mode of the progress
   * @group Props
   */
  @Input() mode = 'determinate';
  /**
   * Color for the background of the progress.
   * @group Props
   */
  @Input() color: string | undefined;

  @ContentChildren(TemplateDirective) templates!: QueryList<TemplateDirective>;

  contentTemplate!: TemplateRef<any>;

  constructor() {}
  ngAfterContentInit() {
    this.templates?.forEach(template => {
      switch (template.name) {
        case 'content':
          this.contentTemplate = template.template;
          break;

        default:
          this.contentTemplate = template.template;
      }
    });
  }
}
